import * as Sentry from "@sentry/react";

let initialized = false;

export function initSentry() {
  if (initialized || typeof window === "undefined") return;
  // DSN is a public identifier (safe to ship in client bundle). Env override is
  // supported, but a hardcoded production DSN is kept as fallback because this
  // template's .env is auto-managed and cannot host custom VITE_ vars.
  const dsn =
    (import.meta.env.VITE_SENTRY_DSN as string | undefined) ??
    "https://51e37705e2a6e3a7efcc5341e44866ba@o4511448239439872.ingest.us.sentry.io/4511448248287232";
  if (!dsn) return;
  Sentry.init({
    dsn,
    release: __SENTRY_RELEASE__,
    environment: import.meta.env.MODE === "production" ? "production" : "development",
    tracesSampleRate: 1.0,
    allowUrls: [/myecrin\.app/, /myecrin\.com/, /caileve\.app/, /caileve\.com/],
    beforeSend(event, hint) {
      try {
        const error = hint?.originalException;
        if (
          error instanceof TypeError &&
          typeof (error as TypeError).message === "string" &&
          (error as TypeError).message.toLowerCase().includes("failed to fetch")
        ) {
          return null;
        }
        if (event.tags?.source === "milestones-fetch") {
          return null;
        }
        // Supabase auth LockManager noise — unactionable,
        // affects 0 users, from Supabase internals not app code
        if (
          typeof event.message === "string" &&
          event.message.includes("LockManager lock") &&
          event.message.includes("immediately failed")
        ) {
          return null;
        }
        if (
          hint?.originalException instanceof Error &&
          hint.originalException.message.includes("LockManager lock") &&
          hint.originalException.message.includes("immediately failed")
        ) {
          return null;
        }
        // Also catch auto-captured rejections where the message lives in
        // exception.values (Sentry global handler path).
        const lockHit = event.exception?.values?.some(
          (v) =>
            typeof v?.value === "string" &&
            v.value.includes("LockManager lock") &&
            v.value.includes("immediately failed"),
        );
        if (lockHit) {
          return null;
        }
        if (
          typeof event.message === "string" &&
          event.message.toLowerCase().includes("failed to fetch")
        ) {
          return null;
        }
        const host = window.location.hostname;
        if (
          host.includes("lovable.app") ||
          host.includes("localhost") ||
          host === "127.0.0.1"
        ) {
          return null;
        }
      } catch {
        return null;
      }
      return event;
    },
    // Session tracking is enabled by default in @sentry/react v8+
    integrations: [Sentry.browserTracingIntegration()],
  });
  initialized = true;
}

export function setSentryUser(userId: string | null) {
  if (!initialized) return;
  if (userId) {
    Sentry.setUser({ id: userId });
  } else {
    Sentry.setUser(null);
  }
}

export { Sentry };